export interface FilterOption<T extends string> {
  key: T;
  label: string;
}

interface ChartFilterBarProps<T extends string> {
  label: string;
  options: readonly FilterOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

/** @graph-connects none */
export function ChartFilterBar<T extends string>({
  label,
  options,
  value,
  onChange,
}: ChartFilterBarProps<T>) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-[var(--color-text-secondary)]">{label}:</span>
      <div className="flex rounded-lg border border-[var(--color-border)]">
        {options.map((opt, i) => (
          <button
            key={opt.key}
            type="button"
            onClick={() => {
              onChange(opt.key);
            }}
            className={`px-3 py-1.5 text-xs transition-colors ${
              value === opt.key
                ? 'bg-[var(--color-accent-primary)] text-white'
                : 'text-[var(--color-text-secondary)] hover:bg-[var(--color-bg-subtle)]'
            } ${i === 0 ? 'rounded-l-lg' : 'border-l border-[var(--color-border)]'} ${i === options.length - 1 ? 'rounded-r-lg' : ''}`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
